module.exports = __webpack_public_path__ + "static/media/statusfeed-wireframe.7ea4efe5.png";